import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-visor',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule, ButtonModule
  ],
  templateUrl: './visor.component.html',
  styleUrl: './visor.component.scss'
})
export class VisorComponent implements OnInit {
  @Input() title !: string;
  @Input() inline !: boolean;

  show = false;
  url !: SafeResourceUrl | undefined;
  height?: string;

  button1Label !: string;
  private _button1Source = new Subject();
  button1Source$ = this._button1Source.asObservable();

  button2Label !: string;
  private _button2Source = new Subject();
  button2Source$ = this._button2Source.asObservable();

  constructor(private sanitizer: DomSanitizer, private _router: Router) {
  }

  get isMobile() {
    return window.innerWidth <= 700;
  }

  get isButton1Visible() {
    return !!this.button1Label;
  }

  get isButton2Visible() {
    return !!this.button2Label;
  }

  ngOnInit(): void {
    if (!this.title) this.title = 'Visualizador de documentos'
  }

  showDialog(archivo: Blob): void {
    this.show = true;
    if (archivo) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(archivo));
    }
  }

  closeDialog(): void {
    this.url = undefined;
    this.show = false;
  }

  onButton1Click() {
    this._button1Source.next(true);
  }

  onButton2Click() {
    this._button2Source.next(true);
  }
}
